import { render, staticRenderFns } from "./AiRequestsCard.vue?vue&type=template&id=ace9c5c4&scoped=true"
import script from "./AiRequestsCard.vue?vue&type=script&lang=js"
export * from "./AiRequestsCard.vue?vue&type=script&lang=js"
import style0 from "./AiRequestsCard.vue?vue&type=style&index=0&id=ace9c5c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace9c5c4",
  null
  
)

export default component.exports